import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import "../../styles/Login.css";

const Register = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("")
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("")
  const [error, setError] = useState("");
  const [loading, setLoading] =useState(false);



  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://ecom-api.applligentdemo.com/users/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password, role }),
      });
      
      const data = await res.json();
      alert(JSON.stringify(data));

      if (res.ok && data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("isAuthenticated", "true");
        navigate("/dashboard");
        setName("");
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2 className="text-center mb-4">User Register</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleLogin}>
            <Form.Group className="floating-label mb-3">
            <Form.Control
              type="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <Form.Label>Name</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Form.Label>Email address</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Form.Label>Password</Form.Label>
          </Form.Group>

          <Form.Group className="floating-label mb-3">
            <Form.Control
              type="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            />
            <Form.Label>Role</Form.Label>
          </Form.Group>

          <Button
            variant="dark"
            type="submit"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <a href="/forget-password">Forgot Password?</a>
        </div>
      </div>
    </div>
  );
};

export default Register;